import React from 'react'
import {ReactComponent as ArrowLeft} from '../../../assets/icons/arrow-left.svg'
import {ReactComponent as ArrowRight} from '../../../assets/icons/arrow-right.svg'
import Select from '../../../shared/Select'

const Pagination = ({currentPage, totalPages = 50, onPageChange, pageSize, onPageSizeChange}) => {
    const renderPageNumbers = () => {
        const pages = []
        const delta = 2

        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(
                    <button key={i} className={currentPage === i ? 'active' : ''} onClick={() => onPageChange(i)}>
                        {i}
                    </button>
                )
            }
        } else {
            pages.push(
                <button key={1} className={currentPage === 1 ? 'active' : ''} onClick={() => onPageChange(1)}>
                    1
                </button>
            )

            if (currentPage > delta + 2) {
                pages.push(<span key="ellipsis-start">...</span>)
            }

            const start = Math.max(2, currentPage - delta)
            const end = Math.min(totalPages - 1, currentPage + delta)

            for (let i = start; i <= end; i++) {
                pages.push(
                    <button key={i} className={currentPage === i ? 'active' : ''} onClick={() => onPageChange(i)}>
                        {i}
                    </button>
                )
            }

            if (currentPage < totalPages - delta - 1) {
                pages.push(<span key="ellipsis-end">...</span>)
            }

            if (totalPages > 1) {
                pages.push(
                    <button key={totalPages} className={currentPage === totalPages ? 'active' : ''} onClick={() => onPageChange(totalPages)}>
                        {totalPages}
                    </button>
                )
            }
        }

        return pages
    }

    const pageSizeOptions = [
        { label: '20 rows', value: 20 },
        { label: '50 rows', value: 50 },
        { label: '100 rows', value: 100 }
    ]

    return (
        <div className="pagination-controls">
            <div className="show-entries">
                <span>Show:</span>
                <Select
                    className="page-size-select"
                    value={pageSizeOptions.find(option => option.value === pageSize)}
                    onChange={(option) => onPageSizeChange(option.value)}
                    options={pageSizeOptions}
                    isSearchable={false}
                />
                <span>entries</span>
            </div>

            <div className="pagination">
                <button disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)}>
                    <ArrowLeft />
                </button>

                {renderPageNumbers()}

                <button disabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)}>
                    <ArrowRight />
                </button>
            </div>
        </div>
    )
}

export default Pagination

